const PaymentProcessing = () => {
  return (
    <>
      <div className="payment-container">
        <div className="payment-card">
          <div className="spinner-container">
            <div className="ant-spinner"></div>
          </div>

          <h2 className="payment-title">Processing Payment</h2>

          <p className="payment-description">
            Please wait while we process your payment. Do not close or refresh
            this page.
          </p>

          <div className="progress-container">
            <div className="progress-bar"></div>
          </div>

          <p className="payment-footer">
            This may take a few moments. Thank you for your patience.
          </p>
        </div>
      </div>
    </>
  );
};

export default PaymentProcessing;
